import React from 'react';
import './MessageModal.css';

const MessageModal = ({ message, type = 'info', onClose, show = false }) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      default:
        return 'ℹ';
    }
  };

  const getTypeClass = () => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  return (
    <div className="message-modal-overlay" onClick={onClose}>
      <div className={`message-modal ${getTypeClass()}`} onClick={(e) => e.stopPropagation()}>
        <div className="message-modal-content">
          <div className="message-modal-icon">{getIcon()}</div>
          <div className="message-modal-message">{message}</div>
        </div>
        <div className="message-modal-actions">
          <button className="message-modal-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;

